import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { PaymentService } from "../../shared/services/payment.service";
import { PaymentRequest } from "../../shared/models/makepaymentReq";
import { PaymentDetails } from "../../shared/models/paymentdetails";
import { USSDPaymentRes } from "../../shared/models/ussdmakePaymentRes";
import { Router, ActivatedRoute } from "@angular/router";
import { FinalTxnStatus } from "../../shared/models/transaction.status";
import { WhiteLabelInfo } from "src/app/core/models/model";
import { urlShortener } from "src/app/core/constants/constants";

@Component({
  selector: "app-ussd",
  templateUrl: "./ussd.component.html",
  styleUrls: ["./ussd.component.css"],
  standalone: false,
})
export class UssdComponent implements OnInit, OnChanges {
  paymentRef: string;
  refereshLink;
  ussdPaymentRequest = new PaymentRequest();
  // paymentDetails: PaymentDetails;
  banks: any;
  selectedBank: string;
  bankName: string;
  paymentReference: string;
  ussdPaymentRes = new USSDPaymentRes();
  isBankAllowed: boolean = false;
  isProcessing: boolean = false;
  @Input() paymentDetails: PaymentDetails;
  @Output() isMakingPayment = new EventEmitter();
  paymentStatus = ["CREATED", "ONGOING", "ABANDONED", "FAILED", "SUCCESS"];
  message: string = "";
  timeSpent: number = 0;

  isDisabled: boolean;

  finalTxnStatus = new FinalTxnStatus();
  show = false;

  @Input() whiteLabelInfo: WhiteLabelInfo;
  bankCode: string = "";
  constructor(
    private route: ActivatedRoute,
    private payservice: PaymentService,
    private router: Router,
  ) {
    this.refereshLink = this.route.snapshot.params["payRef"];
  }

  ngOnInit() {
    if (
      sessionStorage.getItem("ussd") != null &&
      sessionStorage.getItem("bankCode") !== null
    ) {
      let ussd = JSON.parse(sessionStorage.getItem("ussd"))
        ? JSON.parse(sessionStorage.getItem("ussd"))
        : "";
      let bankCode = sessionStorage.getItem("bankCode");

      if (ussd && bankCode) {
        this.isProcessing = false;
        this.isDisabled = true;
        this.ussdPaymentRes = ussd;
        this.bankCode = bankCode;
      }
    }

    this.isBankAllowed = false;
    this.getBanks();
    this.route.params.subscribe((res) => (this.paymentRef = res.payRef));

    this.setPaymentDetails(this.paymentDetails);
    // this.showStatus();
  }

  ngOnChanges(changes) {
    this.paymentDetails = changes["paymentDetails"].currentValue;
    this.setPaymentDetails(this.paymentDetails);
  }

  //isMaking Payment
  // this is emmitted when there is need to disable other payment option during an ongoing payment.

  refereshPage() {
    this.isBankAllowed = false;
    this.getBanks();
    this.bankName = "";
    this.isMakingPayment.emit("");
  }

  getBanks() {
    this.payservice.getUssdBanks().subscribe((data) => {
      this.banks = data.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  getBankUSSD() {
    this.isProcessing = true;
    this.ussdPaymentRequest.paymentChannel = "USSD";

    this.payservice.makePayment(this.ussdPaymentRequest).subscribe(
      async (data: USSDPaymentRes) => {
        this.ussdPaymentRes = await { ...data };

        this.isDisabled = true;
        sessionStorage.setItem("bankCode", this.ussdPaymentRequest.bankCode);
        sessionStorage.setItem("ussd", JSON.stringify(this.ussdPaymentRes));
        if (this.ussdPaymentRes.status == "FAILED") {
          this.router.navigate([
            `/failure/${this.paymentDetails.amount}/${
              this.paymentDetails.referenceId
            }/${btoa(this.paymentDetails.callbackURL)}`,
          ]);
        } else {
          this.isBankAllowed = true;
        }
        this.isProcessing = false;
      },
      (error) => {
        this.router.navigate([
          `/failure/${this.paymentDetails.amount}/${
            this.paymentDetails.referenceId
          }/${btoa(this.paymentDetails.callbackURL)}`,
        ]);
        this.isProcessing = false;
      },
    );
  }

  setPaymentDetails(details) {
    this.ussdPaymentRequest.reference = details.referenceId;
    this.ussdPaymentRequest.clientId = details.clientId;
    this.ussdPaymentRequest.amount = details.amount;
    this.ussdPaymentRequest.currency = details.currency;
    this.ussdPaymentRequest.callbackUrl = details.callbackURL;
    this.ussdPaymentRequest.paymentChannel = "USSD";
    this.ussdPaymentRequest.userId = details.userId;
    this.ussdPaymentRequest.paymentUrl = details.paymentUrl;
  }

  generateUSSD(code) {
    this.selectedBank = code; //take this out
    this.isMakingPayment.emit("ussd");
    this.ussdPaymentRequest.bankCode = code;
    this.getBankUSSD();
  }

  backGroundStatusCheck() {
    this.payservice
      .checkPaymentStatus(
        this.ussdPaymentRequest.clientId,
        this.ussdPaymentRequest.reference,
      )
      .subscribe(
        (data) => {
          this.setResponseMessage(data["status"]);
        },
        (error) => {
          this.isProcessing = false;
          this.message = error.error.responseMessage;
          this.showStatus();
        },
      );
  }

  checkPaymentStatus() {
    this.isProcessing = true;
    this.payservice
      .checkPaymentStatus(
        this.ussdPaymentRequest.clientId,
        this.ussdPaymentRequest.reference,
      )
      .subscribe(
        (data) => {
          this.setResponseMessage(data["status"]);
          this.isProcessing = false;
        },
        (error) => {
          this.isProcessing = false;
          this.message = error.error.responseMessage;
          this.showStatus();
        },
      );
  }

  timeLeft: number = 30;
  interval = null;
  //used to check the payment status at interval
  //removed for resource management reasons
  //should there be a use, Kindly uncomment from the getussd iplementation
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeSpent = this.timeSpent + 30;
        this.backGroundStatusCheck();
        this.timeLeft = 30;
      }
    }, 3000);
  }

  showStatus() {
    let contxt = this;
    this.show = true;
    setTimeout(function () {
      contxt.show = false;
      this.message = "";
      return;
    }, 3500);
  }

  setResponseMessage(response) {
    if (response == "ONGOING") {
      this.message = "Transaction Waiting";
      this.showStatus();
      return;
    }
    if (response == "CREATED") {
      this.message = "Transaction yet to be started";
      // this.timeLeft = 50;
      this.showStatus();
      return;
    }

    if (response == "FAILED" || response == "ABANDONED") {
      this.router.navigate([
        `/failure/${this.paymentDetails.amount}/${
          this.paymentDetails.referenceId
        }/${btoa(this.paymentDetails.callbackURL)}`,
      ]);
      // clearInterval(this.interval);
      // this.isMakingPayment.emit("bank");
    }
    if (response == "SUCCESS") {
      let callbackUrl = this.ussdPaymentRequest.callbackUrl
        ? this.ussdPaymentRequest.callbackUrl
        : "empty";
      this.finalTxnStatus.amount = this.paymentDetails.amount;
      this.finalTxnStatus.callbackUrl = urlShortener(
        this.paymentDetails.callbackURL,
      );
      this.finalTxnStatus.currency = this.paymentDetails.currency;
      this.finalTxnStatus.status = response == "SUCCESS" ? "success" : "failed";

      this.router.navigate([
        `/status/${btoa(JSON.stringify(this.finalTxnStatus))}`,
      ]);
      // clearInterval(this.interval);
      return;
    } else {
      this.message = response;
      this.showStatus();
      return;
    }
  }
}
